module.exports = __webpack_public_path__ + "static/media/headshot.aecd7033.jpg";